// import 'server-only';
import { cache as memoizedCache } from 'react';
import { getTranslations } from 'next-intl/server';
import { Locale } from '@headless-workspace/config';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { CommonDI, ProductDetailSlotsRepositoryType } from '../../../../DI';
import { PaymentMethodsValue } from '../slots';

export const getMemoPaymentMethods = memoizedCache(async (locale: Locale): Promise<PaymentMethodsValue> => {
    const t = await getTranslations('Discover.Pdp.information.buyNowPayLater');

    const paymentMethodsValueResult = await CommonDI.get(ProductDetailSlotsRepositoryType).getPaymentMethods(locale);
    const paymentMethodsValue = unwrapResultSuccess(paymentMethodsValueResult) ?? {};
    const paymentMethodsUrl = `${t('url')}`;

    return {
        items: paymentMethodsValue.items,
        paymentMethodsUrl,
    };
});
